import React, { Component } from "react";

import Close16 from "@carbon/icons-react/lib/close/16";
import DateTimePicker from "../../helpers/DateTimePicker";
import Delete16 from "@carbon/icons-react/lib/delete/16";
import FindSaipemCompilers from "../common/FindSaipemCompilers";
import HocCardAttachments from "./HocCardAttachments";
import HocCardRepository from "../../helpers/api/HocCardRepository";
import PageBreadCrumb from "../../helpers/PageBreadCrumb";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import { AppContext } from "../../helpers/context/AppContext";
import { Checkbox, FormGroup, TextInput, DropdownSkeleton, Button, DatePickerSkeleton, Form, FormLabel, Loading, TextArea } from "carbon-components-react";
import { ComboBox } from "../../helpers/ComboBox";
import { ConfirmAlertCustom } from "../../helpers/ConfirmAlertCustom";
import { FindGHRSEmployer } from "../common/FindGHRSEmployer";
import { CAROwnerManualInputModal } from "./CAROwnerManualInputModal";
import { IsInRole } from "../../helpers/authorization/Policies";
import { Online } from "../common/OnLineOffLine";
import { api, hoccard, me, registry, dynamic } from "../../helpers/api/api";
import { getSuccess, getError, entitiesLabels, apioperation, DateFormat } from "../../helpers/Constants";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { v4 as uuid } from "uuid";
import _sortBy from 'lodash/sortBy'; //RITM1197573

export default class HocCardDetail extends Component {
	statuses = ["Open", "Closed"];
	completionStatuses = ["Not Reviewed", "Reviewed"];

	hocCardProps = {
		idProject: null,
		idHocType: null,
		idHazardType: null,
		idHocPriority: null,
		idLifeSavingRule: null,
		idInfoOriginator: null,
		status: null,
		immediateActions: null,
		comments: null,
		description: null,
		location: null,
		occurredAt: null,
		additionalInfo: null,
		userReportedBy: null,
		occurredAt: null,
		idHocCardCar: null,
		idWorkSite: null,
		idCompiler: null,
		code: null,
		localId: null,
		idHocCardSource: null,
		completionStatus: null,
		attachments: [],
		hocCardCAR: {
			id: null,
			dueDate: null,
			description: null,
			idEmployer: null,
			idOwnerSaipem: null,
			idGenericOwner: null,
			owner: null,
			ownerSaipem: null,
			genericOwner: null,
		},
		nameEmp: "",
	};

	constructor(props) {
		super(props);

		this.validator = new SimpleReactValidator();

		this.hocCardId = this.props.match.params.id;

		this.state = {
			hocCardModel: { ...this.hocCardProps },

			selectedLanguage: '',
			openModal: null,

			worksites: [],
			isLoadingWorksites: false,
			hoctypes: [],
			isLoadingHocTypes: false,
			hazardtypes: [],
			isLoadingHazardTypes: false,
			hocpriorities: [],
			isLoadingHocPriorities: false,
			lifesavingrules: [],
			isLoadingLifeSavingRules: false,
			infooriginators: [],
			isLoadingInfoOriginators: false,
			hocCardSources: [],
			isLoadingHocCardSources: false,
			hocCardTranslate: [], // RITM0954296 
		};
	}

	componentDidMount() {
		this.getHocCardTranslate();
		this.getUserWorksite();
		this.getHocType();
		this.getHazardType();
		this.getHocPriority();
		this.getLSR();
		this.getInfoOriginator();
		this.getHocCardSources();

		if (this.hocCardId != null) this.getHOCCARDForEdit(this.hocCardId);
	}

	// Entities getters

	getUserWorksite = () => {
		this.setState({ isLoadingWorksites: true });
		me.getAll("worksites")
			.then((response) => {
				this.setState({
					worksites: response.data,
					isLoadingWorksites: false,
				});
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
			});
	};

	getHocType = () => {
		this.setState({ isLoadingHocTypes: true });
		dynamic
			.getAll("hoctype", { params: { page: 0 } })
			.then((response) => {
				const data = response.data.itemList;
				this.setState({ hoctypes: data.filter((a) => moment(a.validUntil).isSameOrAfter(moment()) || a.id == this.state.hocCardModel?.idHocType) });
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.HOCTYPE, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingHocTypes: false });
			});
	};

	getHazardType = () => {
		this.setState({ isLoadingHazardTypes: true });
		dynamic
			.getAll("hazardtype", { params: { page: 0 } })
			.then((response) => {
				const data = response.data.itemList;
				this.setState({ hazardtypes: data.filter((a) => moment(a.validUntil).isSameOrAfter(moment()) || a.id == this.state.hocCardModel.idHazardType) }); //RITM1015981
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.HAZARDTYPE, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingHazardTypes: false });
			});
	};

	getHocPriority = () => {
		this.setState({ isLoadingHocPriorities: true });
		dynamic
			.getAll("hocpriority", { params: { page: 0 } })
			.then((response) => {
				const data = response.data.itemList;
				this.setState({ hocpriorities: data });
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.HOCPRIORITY, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingHocPriorities: false });
			});
	};

	getLSR = () => {
		this.setState({ isLoadingLifeSavingRules: true });
		dynamic
			.getAll("lifesavingrule", { params: { page: 0 } })
			.then((response) => {
				const data = response.data.itemList;
				this.setState({ lifesavingrules: data });
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.LIFESAVINGRULEVIOLATION, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingLifeSavingRules: false });
			});
	};

	getInfoOriginator = () => {
		this.setState({ isLoadingInfoOriginators: true });
		dynamic
			.getAll("infooriginator", { params: { page: 0 } })  //RITM1197573
			.then((response) => {
				const { data } = response;
				this.setState({ infooriginators: _sortBy(data.itemList, "id") }); //RITM1197573
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.INFOORIGINATOR, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingInfoOriginators: false });
			});
	};

	getHocCardSources = () => {
		this.setState({ isLoadingHocCardSources: true });
		hoccard.sources
			.getAll()
			.then((response) => {
				this.setState({ hocCardSources: response.data });
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.HOCCARDSOURCES, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingHocCardSources: false });
			});
	};

	getHOCCARDForEdit = (id) => {
		this.setState({ isLoadingElement: true });

		hoccard
			.get(id)
			.then(async (response) => {
				if (response.status == 200) {
					this.validator.hideMessages();
					await this.getProjectbyWorkSite(response.data.idWorkSite);

					response.data.attachments = response.data.attachments.map((a) => {
						if (a.attachment != null) {
							a.attachment.type = a.attachment.type || "Pictures";
							return a;
						}
					});

					this.setState(
						{
							hocCardModel: response.data,
							isLoadingElement: false,
						},
						() => {
							response.data.attachments.forEach((a) => {
								a.loading = true;
								this.queryAttachmentAvailability(a);
							});
							this.getHocType();
							this.getHazardType(); //RITM1015981
						}
					);
				}
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.HOCCARD, apioperation.GET));
			})
			.finally(() => {
				this.validator.hideMessages();
				this.setState({ isLoadingElement: false });
			});
	};

	getProjectbyWorkSite = async (idWorkSite) => {
		try {
			const list = await HocCardRepository.getWorkSiteProject();
			const projects = list.filter((res) => res.idWorkSite === idWorkSite).map((ele) => ({ id: ele.idProject, name: ele.project }));
			this.setState({
				project: projects,
			});
		} catch (error) {
			showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
		}
	};

	// Form handlers
	handleChangeModel = (el) => {
		const inputName = el.target.name;
		const inputValue = el.target.value;
		this.updateState(inputName, inputValue, "hocCardModel");
	};
	handleTextAreaChange(value, inputName) {
		this.setState((prevState) => {
			const hocCardModel = { ...this.state.hocCardModel };
			hocCardModel[inputName] = value ? value : "";
			return { hocCardModel };
		});
	}
	updateStateDP = (inputName, inputValue, objName) => {
		this.setState((prevState) => ({
			[objName]: {
				...prevState[objName],
				[inputName]: inputValue,
			},
		}));
	};

	handleChangeCombo = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem.id : null;

		const statusCopy = { ...this.state };
		statusCopy[objName][inputName] = inputValue;
		//RITM1070983
		if(inputName === 'idHocType' && (selectedItem && selectedItem.code === 'HOCTYPE001_POS'))
		{
			statusCopy[objName]["idHazardType"] = null;
			statusCopy[objName]["idLifeSavingRule"] = null;
			statusCopy[objName]["stopWorkAuthority"] = false;
			statusCopy[objName]["fiveStars"] = false;
			if (statusCopy.hocCardModel.hocCardCAR == null) {
				statusCopy.hocCardModel.hocCardCAR = {};
			}
			statusCopy.hocCardModel.hocCardCAR.idOwnerSaipem = null;
			statusCopy.hocCardModel.hocCardCAR.nameEmployer = null;
			statusCopy.hocCardModel.hocCardCAR.ownerSaipem = null;
			statusCopy.hocCardModel.hocCardCAR.idEmployer = null;
			statusCopy.hocCardModel.hocCardCAR.owner = null;
			statusCopy.hocCardModel.hocCardCAR.idGenericOwner = null;
			statusCopy.hocCardModel.hocCardCAR.genericOwner = null;
			statusCopy.hocCardModel.hocCardCAR.description = null;
			statusCopy.hocCardModel.hocCardCAR.dueDate = null;
			statusCopy[objName]["status"] = null;
			if(statusCopy.hasOwnProperty("hocCardCAR"))
				statusCopy["hocCardCAR"]["dueDate"] = null;
		}
		//End
		this.setState(statusCopy);
	};

	handleChangeComboWorksite = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem.id : null;
		const statusCopy = { ...this.state };
		statusCopy[objName][inputName] = inputValue;
		statusCopy.project = null;
		statusCopy.hocCardModel.idProject = null;

		this.setState(statusCopy, () => {
			if (inputValue) {
				this.getProjectbyWorkSite(inputValue);
			}
		});
	};

	handleChangeComboStatusModel = (_, objName) => {
		objName != "All" ? (objName == "Closed" ? (this.state.hocCardModel.status = "Closed") : (this.state.hocCardModel.status = "Opened")) : (this.state.hocCardModel.status = null);

		const statusCopy = { ...this.state.hocCardModel };
		statusCopy.status = objName;
		this.setState(statusCopy);
	};

	handleChangeComboCompletionStatusModel = (_, objName) => {
		const stateModelCopy = { ...this.state.hocCardModel };
		stateModelCopy.completionStatus = objName;
		this.setState({ hocCardModel: stateModelCopy });
	};

	handleChangeModelCar = (el) => {
		const inputName = el.target.name;
		const inputValue = el.target.value;

		this.updateStateCAR(inputName, inputValue, "hocCardCAR");
	};

	updateStateDPCAR = (inputName, inputValue, objName) => {
		const statusCopy = { ...this.state.hocCardModel };
		if (statusCopy.hocCardCAR == null) {
			statusCopy.hocCardCAR = {};
		}
		statusCopy[objName][inputName] = inputValue;

		this.setState({ hocCardModel: statusCopy });
		this.setState((prevState) => ({
			[objName]: {
				...prevState[objName],
				[inputName]: inputValue,
			},
		}));
	};

	deleteEmployer = () => {
		const statusCopy = { ...this.state.hocCardModel };
		statusCopy.hocCardCAR.owner = null;
		statusCopy.hocCardCAR.idEmployer = null;
		statusCopy.hocCardCAR.idOwnerSaipem = null;
		statusCopy.hocCardCAR.ownerSaipem = null;
		statusCopy.hocCardCAR.idGenericOwner = null;
		statusCopy.hocCardCAR.genericOwner = null;
		this.setState({ hocCardModel: statusCopy });
	};

	handleChangeModal = (m) => {
		this.setState({ openModal: m });
	};

	setEmployer = (employer) => {
		if (employer && employer.id) {
			const statusCopy = { ...this.state.hocCardModel };
			if (statusCopy.hocCardCAR == null) {
				statusCopy.hocCardCAR = {};
			}
			statusCopy.hocCardCAR.idEmployer = employer.id;
			statusCopy.hocCardCAR.nameEmployer = employer.name;
			statusCopy.hocCardCAR.owner = employer;
			statusCopy.hocCardCAR.idOwnerSaipem = null;
			statusCopy.hocCardCAR.ownerSaipem = null;
			statusCopy.hocCardCAR.idGenericOwner = null;
			statusCopy.hocCardCAR.genericOwner = null;
			this.setState({ hocCardModel: statusCopy, openModal: null });
			this.setState({ selectEmployer: employer });
		}
	};

	setSaipemOwner = (employer) => {
		if (employer && employer.id) {
			const statusCopy = { ...this.state.hocCardModel };
			if (statusCopy.hocCardCAR == null) {
				statusCopy.hocCardCAR = {};
			}
			statusCopy.hocCardCAR.idOwnerSaipem = employer.id;
			statusCopy.hocCardCAR.nameEmployer = employer.name;
			statusCopy.hocCardCAR.ownerSaipem = employer;
			statusCopy.hocCardCAR.idEmployer = null;
			statusCopy.hocCardCAR.owner = null;
			statusCopy.hocCardCAR.idGenericOwner = null;
			statusCopy.hocCardCAR.genericOwner = null;

			this.setState({ hocCardModel: statusCopy, openModal: null });
			this.setState({ selectEmployer: employer });
		}
	};

	setGenericOwner = (genericOwner) => {
		const hocCardModel = { ...this.state.hocCardModel };
		if (hocCardModel.hocCardCAR == null) hocCardModel.hocCardCAR = {};
		hocCardModel.hocCardCAR.genericOwner = genericOwner;
		if (hocCardModel.hocCardCAR.idGenericOwner == null) hocCardModel.hocCardCAR.genericOwner.id = hocCardModel.hocCardCAR.idGenericOwner = uuid();
		hocCardModel.hocCardCAR.idEmployer = null;
		hocCardModel.hocCardCAR.owner = null;
		hocCardModel.hocCardCAR.idOwnerSaipem = null;
		hocCardModel.hocCardCAR.ownerSaipem = null;
		this.setState({ hocCardModel, openModal: null });
	};

	handleSubmitInsert = () => {
		if (this.validator.allValid()) {
			this.setState({ isSubmitted: true });

			const datiForm = this.state.hocCardModel;
			datiForm.id = this.state.hocCardModel.id || uuid();
			if (datiForm.hocCardCAR != null) {
				if ((datiForm.hocCardCAR.description != null && datiForm.hocCardCAR.description != "") || datiForm.hocCardCAR.dueDate != null || datiForm.hocCardCAR.idEmployer != null) {
					// controllo che i due cambi siano diversi da null per creare/modficare una car

					// inserimento
					const newid = uuid();
					datiForm.idHocCardCar = newid;
					datiForm.hocCardCAR.id = newid;
				} else if ((datiForm.hocCardCAR.description == null || datiForm.hocCardCAR.description == "") && datiForm.hocCardCAR.dueDate == null && datiForm.hocCardCAR.idEmployer == null) {
					// per inserimento e modifica imposta la car a null i campi della car sono  null
					datiForm.idHocCardCar = null;
					datiForm.hocCardCAR = null;
				} else {
					// mostra messaggio errore e non effettua modifiche
					showNotification.error(`${this.state.hocCardTranslate?.msgError}`, this.state.hocCardTranslate?.msghocCardCAR);
					return;
				}
				if (!this.hocCardId && this.state.hocCardModel.attachments?.length > 0) {
					this.state.hocCardModel.attachments.forEach((a) => (a.idHocCard = datiForm.id));
				}
			}

			const method = this.hocCardId ? hoccard.put(datiForm, this.state.hocCardModel.id) : hoccard.post(datiForm);

			//RITM1197573
			const infooriginators = (this.state.infooriginators || []).filter(
				(el) => (el.inUse) || this.state.hocCardModel?.idInfoOriginator == el.id);

			method
				.then(async (response) => {
					if (response.status === 200) {
						const dataList = {
							id: datiForm.id,
							description: datiForm.description,
							project: this.state.project && this.state.hocCardModel.idProject ? this.state.project.find((el) => el.id === this.state.hocCardModel.idProject).name : null,
							hazardType: (this.state.hazardtypes || []).find((el) => el.id === this.state.hocCardModel.idHazardType)?.name, //RITM1070983
							infoOriginator: (infooriginators || []).find((el) => el.id === this.state.hocCardModel.idInfoOriginator).name, //RITM1197573
							reportBy: datiForm.reportBy,
							hocType: (this.state.hoctypes || []).find((el) => el.id === this.state.hocCardModel.idHocType).name,
							status: datiForm.status || datiForm.idHocCardCar != null ? "Opened" : "Closed",
							occurredAt: datiForm.occurredAt,
							isCar: datiForm.idHocCardCar != null,
						};
						await HocCardRepository.updateCachedList(this.state.currentPage, this.state.pageSize, dataList);
						await HocCardRepository.updateCachedDetail(datiForm);
						showNotification.success(this.state.hocCardTranslate?.msgSuccess,  this.hocCardId ? this.state.hocCardTranslate?.msgEditedSucess : this.state.hocCardTranslate?.msgCreatedSucess);

						if(!this.hocCardId){
							this.backToMainSection();
						}
					} else {
						showNotification.error();
					}
				})
				.catch((error) => {
					showNotification.error(this.state.hocCardTranslate?.msgError, this.hocCardId ? this.state.hocCardTranslate?.msgErrorEdit : this.state.hocCardTranslate ?. msgErrorCreate);
				})
				.finally(() => {
					this.setState({
						isSubmitted: false,
					});
				});
		} else {
			this.validator.showMessages();
			showNotification.warning(this.state.hocCardTranslate?.msgWarning, this.state.hocCardTranslate?.msgRequiredFields);
			this.forceUpdate();
		}
	};

	handleCancel = () => {
		// this.props.history.push('/hoccard');
		this.props.history.push("/hocCard?isBack"); // RITM0544922
	};

	backToMainSection = () => {
		// this.props.history.push('/hoccard');
		this.props.history.push("/hocCard?isBack"); // RITM0544922
	};

	// Generic helpers
	updateState = (inputName, inputValue, objName) => {
		const statusCopy = { ...this.state };
		statusCopy[objName][inputName] = inputValue;

		this.setState(statusCopy);
	};

	updateStateCAR = (inputName, inputValue, objName) => {
		const statusCopy = { ...this.state.hocCardModel };
		if (statusCopy.hocCardCAR == null) {
			statusCopy.hocCardCAR = {};
		}
		statusCopy[objName][inputName] = inputValue;

		this.setState({ hocCardModel: statusCopy });
	};

	addNewAttachment = (data) => {
		try {
			if (data == null) return;
			let oldAttachments = this.state.hocCardModel.attachments || [];
			let newItem = {
				id: uuid(),
				idHocCard: this.hocCardId ? this.hocCardId : uuid(),
				idAttachment: data.id,
				attachment: data,
			};

			let newAttachments = oldAttachments.concat([newItem]);
			this.updateState("attachments", newAttachments, "hocCardModel");
		} catch (error) {
			showNotification.error();
		}
	};

	removeAttachment = (id) => {
		if (!id) return;

		let stateModelCopy = { ...this.state.hocCardModel };
		stateModelCopy.attachments = stateModelCopy.attachments.filter((el) => el.idAttachment !== id);
		this.setState({ hocCardModel: stateModelCopy });
	};

	setAttachmentStatus = (id, status, loading) => {
		let hocCardModel = { ...this.state.hocCardModel };
		let attachments = [...hocCardModel.attachments];
		let attachment = hocCardModel.attachments.find((att) => att.idAttachment === id);
		attachment.loading = loading;
		attachment.synching = status;
		hocCardModel.attachments = attachments;
		this.setState({ hocCardModel: hocCardModel });
	};

	queryAttachmentAvailability = (attachmentItem) => {
		api.get(`hoccard/attachments/available/`, encodeURIComponent(attachmentItem.attachment.fileIdentifier)) //RITM1094125
			.then(async (res) => {
				this.setAttachmentStatus(attachmentItem.idAttachment, res.data, false);
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, getError(error, entitiesLabels.HOCCARD_ATTACHMENTS_AVAILABILITY, apioperation.GET));
				this.setAttachmentStatus(attachmentItem.idAttachment, true, false);
			});
	};

	checkAttachmentAvailability = (id) => {
		let attachment = this.state.hocCardModel.attachments.find((a) => a.idAttachment === id);
		this.setAttachmentStatus(id, true, true);
		this.queryAttachmentAvailability(attachment);
	};

	// Delete
	openDeleteHocCardConfirmModal = () => {
		this.setState({
			isDeleteModalOpen: true,
			isDeleting: false,
		});
	};
	//LanguageChange 
	handleChangeLanguage = (event) => {

		window.sessionStorage.removeItem("hocCardTranslate");
		this.setState({ selectedLanguage: event.target.value });
		hoccard.translate.get({ params: { language: event.target.value } })
			.then((response) => {
				this.setState({ hocCardTranslate: response.data });
				window.sessionStorage.setItem("hocCardTranslate", JSON.stringify(this.state.hocCardTranslate));
			});

	};
	//RITM0954296 
	getHocCardTranslate = () => {
		hoccard.translate
			.get({ params: { language: 'English' } })
			.then((response) => {
				this.setState({ hocCardTranslate: response.data });
				window.sessionStorage.setItem("hocCardTranslate", JSON.stringify(this.state.hocCardTranslate));
			})

	};


	deleteItem = () => {
		this.setState({
			isDeleting: true,
		});
		hoccard
			.delete(this.hocCardId)
			.then((response) => {
				if (response.status == 200) {
					// this.props.history.push('/hoccard');
					this.props.history.push("/hocCard?isBack"); // RITM0544922

					this.onCloseConfirm();
					showNotification.success(`${this.state.hocCardTranslate?.msgSuccess}`, this.state.hocCardTranslate?.msgDeletedSucess);
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${this.state.hocCardTranslate?.msgError}`, this.state.hocCardTranslate?.msgErrorDelete);
			})
			.finally(() => {
				this.setState({
					isDeleting: false,
					isDeleteModalOpen: false,
				});
			});
	};

	onCloseConfirm = () => {
		this.setState({
			isDeleteModalOpen: false,
		});
	};

	// Render methods
	renderMainForm = (user) => {
		if (this.state.hocCardModel.hocCardCAR != null) {
			var diffduedate = !this.state.hocCardModel.hocCardCAR.dueDate || moment(this.state.hocCardModel.hocCardCAR.dueDate).isSameOrAfter(moment(this.state.hocCardModel.occurredAt), "day");
		} else {
			var diffduedate = true;
		}

		const isDisable = user && (IsInRole(user, "Administrator") || !this.state.hocCardModel.idCompiler || user.id == this.state.hocCardModel.idCompiler || !this.hocCardId) ? false : true;
		const projectIsDisable = this.state.project == null || this.state.project.length == 0 || isDisable;

		const HocCreated = this.state.hocCardModel.createdOn ? new Date(this.state.hocCardModel.createdOn) : null;

		const idHocTypePOS = (this.state.hoctypes || []).find((el) => el.code === "HOCTYPE001_POS")?.id || null; //RITM1070983

		let hocCardSource = this.hocCardId && this.state.hocCardSources && this.state.hocCardModel.idHocCardSource ? this.state.hocCardSources.find((s) => s.id === this.state.hocCardModel.idHocCardSource)?.name : "";

		const validations = {
			immediateActions: this.validator.message("ImmediateActions", this.state.hocCardModel.immediateActions, "required"),
			location: this.validator.message("Location", this.state.hocCardModel.location, "required"),
			description: this.validator.message("Description ", this.state.hocCardModel.description, "required"),
			occurredAt: this.validator.message("Date Of Occurrence", this.state.hocCardModel.occurredAt, "required"),			
			idInfoOriginator: this.validator.message("HOC raised by", this.state.hocCardModel.idInfoOriginator, "required"),
			idHazardType: this.validator.message("Hazard Type", (this.state.hocCardModel.idHocType === idHocTypePOS ? true : this.state.hocCardModel.idHazardType), "required"), //RITM1070983
			idHocType: this.validator.message("Hoc Type", this.state.hocCardModel.idHocType, "required"),
			idHocPriority: this.validator.message("Hoc Priority", ((this.state.hocCardModel.completionStatus === "Reviewed" && hocCardSource === "Hoc4All") || this.state.hocCardModel.completionStatus === null || this.state.hocCardModel.completionStatus === "") ? this.state.hocCardModel.idHocPriority : true, "required"), //RITM1070983
			duedate: this.validator.message("Due Date", diffduedate, "accepted"),
			idWorkSite: this.validator.message("WorkSite", this.state.hocCardModel.idWorkSite, "required"),
			carEmployer: this.validator.message(
				"Owner",
				this.state.hocCardModel.hocCardCAR?.idEmployer ||
					this.state.hocCardModel.hocCardCAR?.idGenericOwner ||
					this.state.hocCardModel.hocCardCAR?.idOwnerSaipem ||
					this.state.hocCardModel.hocCardCAR?.dueDate ||
					this.state.hocCardModel.hocCardCAR?.description
					?  (this.state.hocCardModel.idHocType === idHocTypePOS ? true : (this.state.hocCardModel.hocCardCAR?.idEmployer || this.state.hocCardModel.hocCardCAR?.idGenericOwner || this.state.hocCardModel.hocCardCAR?.idOwnerSaipem)) //RITM1070983
					: true,
				"required"
			),
			carDescription: this.validator.message(
				"Description",
				this.state.hocCardModel.hocCardCAR?.idEmployer ||
					this.state.hocCardModel.hocCardCAR?.idGenericOwner ||
					this.state.hocCardModel.hocCardCAR?.idOwnerSaipem ||
					this.state.hocCardModel.hocCardCAR?.dueDate ||
					this.state.hocCardModel.hocCardCAR?.description
					? (this.state.hocCardModel.idHocType === idHocTypePOS ? true : this.state.hocCardModel.hocCardCAR?.description) //RITM1070983
					: true,
				"required"
			),
			carDueDate: this.validator.message(
				"DueDate",
				this.state.hocCardModel.hocCardCAR?.idEmployer ||
					this.state.hocCardModel.hocCardCAR?.idGenericOwner ||
					this.state.hocCardModel.hocCardCAR?.idOwnerSaipem ||
					this.state.hocCardModel.hocCardCAR?.dueDate ||
					this.state.hocCardModel.hocCardCAR?.description
					? (this.state.hocCardModel.idHocType === idHocTypePOS ? true : this.state.hocCardModel.hocCardCAR?.dueDate) //RITM1070983
					: true,
				"required"
			),
			// (RITM0544085 & RITM0530003) To not validate the hoc created before the implementation of the new functionality
			project: this.validator.message("Project", projectIsDisable || (HocCreated ? HocCreated < new Date("2022/01/25") : false) ? true : this.state.hocCardModel.idProject, "required"),
			lifeSavingRules: this.validator.message("Life Saving Rules Violation", (HocCreated ? HocCreated < new Date("2022/01/25") : false) ? true : (this.state.hocCardModel.idHocType === idHocTypePOS ? true : this.state.hocCardModel.idLifeSavingRule), "required"), //RITM1070983
		};
		//RITM1197573
        const infooriginators = (this.state.infooriginators || []).filter(
            (el) => (el.inUse) || this.state.hocCardModel?.idInfoOriginator == el.id);
		const selectedItemCombo = {
			idProject: this.state.project ? this.state.project.find((el) => el.id == this.state.hocCardModel.idProject) : [],
			idHocType: (this.state.hoctypes || []).find((el) => el.id == this.state.hocCardModel.idHocType),
			idHazardType: (this.state.hazardtypes || []).find((el) => el.id == this.state.hocCardModel.idHazardType),
			idHocPriority: (this.state.hocpriorities || []).find((el) => el.id == this.state.hocCardModel.idHocPriority),
			idLifeSavingRule: (this.state.lifesavingrules || []).find((el) => el.id == this.state.hocCardModel.idLifeSavingRule),
			idInfoOriginator: (infooriginators || []).find((el) => el.id == this.state.hocCardModel.idInfoOriginator), //RITM1197573
			idWorkSite: (this.state.worksites || []).find((el) => el.id == this.state.hocCardModel.idWorkSite),
			status: this.state.hocCardModel != null ? this.state.hocCardModel.status : null,
			completionStatus: this.state.hocCardModel && this.state.hocCardModel.completionStatus,
		};

		const idCompiler = this.state.hocCardModel?.idCompiler; /*RITM0544698*/
		// const idCarOwner = this.state.hocCardModel.hocCardCAR?.idOwnerSaipem || this.state.hocCardModel.hocCardCAR?.owner?.id || this.state.hocCardModel.hocCardCAR?.idGenericOwner;

		const emailCarOwnerGHRS = this.state.hocCardModel.hocCardCAR?.owner?.email; //RITM0544698
		const idCarOwnerSaipem = this.state.hocCardModel.hocCardCAR?.idOwnerSaipem; //RITM0544698
		const emailCarOwnerGeneric = this.state.hocCardModel.hocCardCAR?.genericOwner?.email; //RITM0544698
		// var idDisableStatus = IsInRole(user, "Administrator") ? false : idCarOwner && user.id !== idCarOwner ;

		// Filtra l'array infooriginators escludendo l'opzione 'SAP'
		const filteredInfoOriginators = infooriginators.filter( //RITM1197573
			(item) => item.name !== 'SAP'
		);

		var idDisableStatus; //RITM0544698

		if (this.state.hocCardModel.hocCardCAR?.id) {
			//RITM0544698
			switch (true) {
				case IsInRole(user, "Administrator") || (idCompiler && idCompiler == user.id):
					idDisableStatus = false;
					break;
				case idCarOwnerSaipem != null:
					idDisableStatus = idCarOwnerSaipem != user.id;
					break;
				case emailCarOwnerGHRS != null:
					idDisableStatus = emailCarOwnerGHRS.toLowerCase() != user.email.toLowerCase();
					break;
				case emailCarOwnerGeneric != null:
					idDisableStatus = emailCarOwnerGeneric.toLowerCase() != user.email.toLowerCase();
					break;
				default:
					idDisableStatus = true;
					break;
			}
		}

		if (idDisableStatus == null) idDisableStatus = true;

		return (
			<Form className="bx--grid--full-width form--multi ">
				{this.state.isLoadingElement ? <Loading /> : ""}
				<div className="bx--row with-separator ">
					<div className="bx--col-lg-12 bx--col-md-8">
						{this.hocCardId ? (
							<FormGroup legendText="" className="bx--col-md-4">
								<div className=" box--informations-all">
									<div className="bx--row box--information show">
										<div className=" information--itmes">
											<div className="information--color ">{this.state.hocCardTranslate?.sourceTitle || 'Source:'}</div> <div className="notification-module">{hocCardSource}</div>{" "}
										</div>
									</div>
								</div>
							</FormGroup>
						) : (
							""
						)}
					</div>
					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class-label">{this.state.hocCardTranslate?.descriptionTitle}
							<br />
							{this.state.hocCardTranslate?.descriptionTitle2}</FormLabel>
						<TextArea
							maxLength={5000}
							id="description"
							name="description"
							alt="hocCardModel"
							placeholder={this.state.hocCardTranslate?.descriptionTitlePlaceholder}
							value={this.state.hocCardModel?.description != null ? this.state.hocCardModel?.description : ""}
							onChange={(e) => this.handleTextAreaChange(e.target.value, "description")}
							invalid={validations.description != null}
							invalidText={this.state.hocCardTranslate?.msgDescription}
							hideLabel
							labelText=""
							light
							rows={4}
							cols={250}
							disabled={isDisable}
						/>
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class-label">{this.state.hocCardTranslate?.immediateActionsTitle}
							<br />
							{this.state.hocCardTranslate?.immediateActionsTitle2}</FormLabel>
						<TextArea
							maxLength={5000}
							id="immediateActions"
							name="immediateActions"
							alt="hocCardModel"
							placeholder={this.state.hocCardTranslate?.immediateActionsTitlePlaceholder}
							value={this.state.hocCardModel?.immediateActions != null ? this.state.hocCardModel?.immediateActions : ""}
							onChange={(e) => this.handleTextAreaChange(e.target.value, "immediateActions")}
							invalid={validations.immediateActions != null}
							invalidText={this.state.hocCardTranslate?.msgImmediateActions}
							hideLabel
							labelText=""
							light
							rows={4}
							cols={250}
							disabled={isDisable}
						/>
					</FormGroup>
					{!this.state.isSubmitted ? "" : <Loading />}
					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel>{this.state.hocCardTranslate?.additionalInfoTitle}
							<br />
							{this.state.hocCardTranslate?.additionalInfoTitle2}</FormLabel>
						<TextArea
							maxLength={5000}
							id="additionalInfo"
							name="additionalInfo"
							alt="hocCardModel"
							placeholder={this.state.hocCardTranslate?.additionalInfoTitlePlaceholder}
							value={this.state.hocCardModel?.additionalInfo != null ? this.state.hocCardModel?.additionalInfo : ""}
							onChange={(e) => this.handleTextAreaChange(e.target.value, "additionalInfo")}
							hideLabel
							labelText=""
							light
							rows={4}
							cols={250}
							disabled={isDisable}
						/>
					</FormGroup>
					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						<FormLabel className="some-class">{this.state.hocCardTranslate?.locationTitle}</FormLabel>
						<TextInput
							id="location"
							name="location"
							placeholder={this.state.hocCardTranslate?.locationTitlePlaceholder}
							required
							value={this.state.hocCardModel.location}
							onChange={this.handleChangeModel}
							type="text"
							labelText=""
							className="bx--text-input  bx--text-input--light"
							disabled={isDisable}
							invalid={validations.location != null}
							invalidText={this.state.hocCardTranslate?.msgLocation}
						/>
						{/*{validations.location}*/}
					</FormGroup>
					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						<FormLabel className="some-class">{this.state.hocCardTranslate?.userReportedByTitle}</FormLabel>
						<TextInput
							id="userReportedBy"
							name="userReportedBy"
							placeholder={this.state.hocCardTranslate?.userReportedByTitlePlaceholder}
							required
							value={this.state.hocCardModel.userReportedBy}
							onChange={this.handleChangeModel}
							type="text"
							labelText=""
							className="bx--text-input  bx--text-input--light"
							disabled={isDisable}
						/>
					</FormGroup>
					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						<FormLabel className="some-class">{this.state.hocCardTranslate?.localIdTitle}</FormLabel>
						<TextInput
							id="localId"
							name="localId"
							placeholder={this.state.hocCardTranslate?.localIdTitlePlaceholder}
							required
							value={this.state.hocCardModel.localId}
							onChange={this.handleChangeModel}
							type="text"
							labelText=""
							className="bx--text-input  bx--text-input--light"
							disabled={isDisable}
						/>
					</FormGroup>

					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						<FormLabel className="some-class">{this.state.hocCardTranslate?.commentsTitle}
							<br />
							{this.state.hocCardTranslate?.commentsTitle2}</FormLabel>
						<TextInput
							id="comments"
							name="comments"
							placeholder={this.state.hocCardTranslate?.commentsTitlePlaceholder}
							required
							value={this.state.hocCardModel.comments}
							onChange={this.handleChangeModel}
							type="text"
							labelText=""
							className="bx--text-input  bx--text-input--light"
							disabled={isDisable}
						/>
					</FormGroup>
					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						<FormLabel className="some-class">{this.state.hocCardTranslate?.dateOfOccurrenceTitle}</FormLabel>
						{this.state.isLoadingDate ? (
							<DatePickerSkeleton />
						) : (
							<DateTimePicker
								value={this.state.hocCardModel.occurredAt}
								type="date"
								placeholder={DateFormat}
								name="occurredAt"
								alt="hocCardModel"
								invalid={validations.occurredAt != null}
								onChange={this.updateStateDP}
								disabled={isDisable}
								disableFutureDate									 
								invalidText={this.state.hocCardTranslate?.msgDateofOccurrence}
							/>
						)}
						{/* RITM0954296 */}
						{/* {validations.occurredAt} */}
						{validations.occurredAt ? (
							<div className="srv-validation-message">
							{this.state.hocCardTranslate?.msgDateofOccurrence}
							</div>
						) : null}
						{/* End */}
					</FormGroup>
					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						<FormLabel className="some-class">{this.state.hocCardTranslate?.hoCraisedbyTitle}</FormLabel>
						{this.state.isLoadingInfoOriginators ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								key={"idInfoOriginator_" + selectedItemCombo.idInfoOriginator}
								id="idInfoOriginator "
								placeholder={this.state.hocCardTranslate?.hoCraisedbyTitlePlaceholder}
								name="idInfoOriginator"
								alt="hocCardModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={selectedItemCombo.idInfoOriginator}
								//items={this.state.infooriginators}
								items={filteredInfoOriginators}
								invalid={validations.idInfoOriginator != null}
								disabled={isDisable}
								invalidText={this.state.hocCardTranslate?.msgHocraised}

							/>
						)}
						{/*validations.idInfoOriginator*/}
					</FormGroup>

					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						<FormLabel>{this.state.hocCardTranslate?.worksitesTitle}</FormLabel>
						{this.state.isLoadingWorksite ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								key={"idWorkSiteM_" + selectedItemCombo.idWorkSite}
								id="idWorkSiteM"
								placeholder={this.state.hocCardTranslate?.worksitesTitlePlaceholder}
								name="idWorkSite"
								alt="hocCardModel"
								onChange={this.handleChangeComboWorksite}
								itemToString={(item) => (item ? item.name : "")}
								selectedItem={selectedItemCombo.idWorkSite}
								items={this.state.worksites}
								invalid={validations.idWorkSite != null}
								disabled={isDisable}
								invalidText={this.state.hocCardTranslate?.msgWorksite}
							/>
						)}
						{/*validations.idWorkSite*/}
					</FormGroup>
					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						<FormLabel className="some-class">{this.state.hocCardTranslate?.projectTitle}{projectIsDisable ? "" : "*"}</FormLabel>
						<ComboBox
							key={"idProject_" + selectedItemCombo.idProject}
							id="idProject"
							placeholder={this.state.hocCardTranslate?.projectTitlePlaceholder}
							name="idProject"
							alt="hocCardModel"
							onChange={this.handleChangeCombo}
							itemToString={(item) => (item ? item.name : "")}
							selectedItem={selectedItemCombo.idProject ? selectedItemCombo.idProject : null}
							items={this.state.project}
							disabled={projectIsDisable}
							invalid={validations.project != null}
							invalidText={this.state.hocCardTranslate?.msgProject}
						/>
						{/*validations.project*/}
					</FormGroup>
					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						{/* RITM1070983 */}
						{/* RITM0954296 */}
						<FormLabel className="some-class">{this.state.hocCardModel.idHocType === idHocTypePOS ? (this.state.hocCardTranslate?.hazardtypesTitle ? this.state.hocCardTranslate.hazardtypesTitle : "Hazard Type") : (this.state.hocCardTranslate?.hazardtypesTitle ? this.state.hocCardTranslate.hazardtypesTitle + "*" : "Hazard Type*")}</FormLabel>
						{this.state.isLoadingHazardTypes ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								key={"idHazardType_" + selectedItemCombo.idHazardType}
								id="idHazardType"
								placeholder={this.state.hocCardTranslate?.hazardtypesTitlePlaceholder}
								name="idHazardType"
								alt="hocCardModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={selectedItemCombo.idHazardType}
								items={this.state.hazardtypes}
								invalid={validations.idHazardType != null}
								disabled={isDisable || (this.state.hocCardModel.idHazardType == null && this.state.hocCardModel.idHocType === idHocTypePOS)} //RITM1070983
								invalidText={this.state.hocCardTranslate?.msgHazard }
							/>
						)}
						{/*validations.idHazardType*/}
					</FormGroup>
					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
						<FormLabel className="some-class">{this.state.hocCardTranslate?.hoctypesTitle}</FormLabel>
						{this.state.isLoadingHocTypes ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								key={"idHocType_" + selectedItemCombo.idHocType}
								id="idSearchHazardType"
								placeholder={this.state.hocCardTranslate?.hoctypesTitlePlaceholder}
								name="idHocType"
								alt="hocCardModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={selectedItemCombo.idHocType}
								items={this.state.hoctypes}
								invalid={validations.idHocType != null}
								disabled={isDisable}
								invalidText={this.state.hocCardTranslate?.msgHoctype}
							/>
						)}
						{/*validations.idHocType*/}
					</FormGroup>

					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4 ">
						{/* RITM1070983 */}
						{/* RITM0954296 */}
						<FormLabel className="some-class">{this.state.hocCardModel.idHocType === idHocTypePOS ? (this.state.hocCardTranslate?.lifesavingrulesTitle ? this.state.hocCardTranslate.lifesavingrulesTitle : "Life Saving Rule Violation") : (this.state.hocCardTranslate?.lifesavingrulesTitle ? this.state.hocCardTranslate.lifesavingrulesTitle + "*" : "Life Saving Rule Violation*")}</FormLabel>
						{this.state.isLoadingLifeSavingRules ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								key={"idLifeSavingRule_" + selectedItemCombo.idLifeSavingRule}
								id="idLifeSavingRule"
								placeholder={this.state.hocCardTranslate?.lifesavingrulesTitlePlaceholder}
								name="idLifeSavingRule"
								alt="hocCardModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={selectedItemCombo.idLifeSavingRule}
								items={this.state.lifesavingrules}
								disabled={isDisable || (this.state.hocCardModel.idLifeSavingRule == null && this.state.hocCardModel.idHocType === idHocTypePOS)} //RITM1070983
								//RITM0544085
								invalid={validations.lifeSavingRules != null}
								invalidText={this.state.hocCardTranslate?.msgLifeSavingRulesViolation}
							/>
						)}
					</FormGroup>

					<div className="bx--col-lg-8 bx--col-md-4 checkboxes">
						<div className="bx--row">
							<FormGroup legendText="" className="bx--col-lg-6 bx--col-md-4 inner-form-group">
								<FormLabel>{this.state.hocCardTranslate?.stopWorkAuthorityTitle}</FormLabel>
								<Checkbox
									id="stopWorkAuthority"
									name="stopWorkAuthority"
									required
									labelText=""
									disabled={isDisable || ((this.state.hocCardModel?.stopWorkAuthority == null || this.state.hocCardModel?.stopWorkAuthority == false) && this.state.hocCardModel.idHocType === idHocTypePOS)} //RITM1070983
									checked={this.state.hocCardModel.stopWorkAuthority == null ? false : this.state.hocCardModel.stopWorkAuthority}
									onChange={(el) => this.updateState("stopWorkAuthority", el, "hocCardModel")}
									className="bx--form-item bx--checkbox-wrapper"
								/>
							</FormGroup>
							<FormGroup legendText="" className="bx--col-lg-6 bx--col-md-4 inner-form-group">
								<FormLabel>{this.state.hocCardTranslate?.fiveStarsTitle}</FormLabel>
								<Checkbox
									id="fiveStars"
									name="fiveStars"
									required
									labelText=""
									disabled={isDisable || ((this.state.hocCardModel?.fiveStars == null || this.state.hocCardModel?.fiveStars == false) && this.state.hocCardModel.idHocType === idHocTypePOS)} //RITM1070983
									checked={this.state.hocCardModel.fiveStars == null ? false : this.state.hocCardModel.fiveStars}
									onChange={(el) => this.updateState("fiveStars", el, "hocCardModel")}
									className="bx--form-item bx--checkbox-wrapper"
								/>
							</FormGroup>
						</div>
					</div>
				</div>
				<div className="bx--row with-separator ">
					<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4 ">
						{/* RITM1070983 */}
						{/* RITM0954296 */}
						<FormLabel className="some-class">{((this.state.hocCardModel.completionStatus === "Reviewed" && hocCardSource === "Hoc4All") || this.state.hocCardModel.completionStatus === null || this.state.hocCardModel.completionStatus === "") ? (this.state.hocCardTranslate?.hocprioritiesTitle ? this.state.hocCardTranslate.hocprioritiesTitle + "*" : "HOC Priority*") : (this.state.hocCardTranslate?.hocprioritiesTitle ? this.state.hocCardTranslate.hocprioritiesTitle : "HOC Priority")}</FormLabel>
						{this.state.isLoadingHocPriorities ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								key={"idHocPriority_" + selectedItemCombo.idHocPriority}
								id="idHocPriority"
								placeholder={this.state.hocCardTranslate?.hocprioritiesTitlePlaceholder}
								name="idHocPriority"
								alt="hocCardModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={selectedItemCombo.idHocPriority}
								items={this.state.hocpriorities}
								invalid={validations.idHocPriority != null}
								disabled={isDisable}
								invalidText={this.state.hocCardTranslate?.msgHocPriority}
							/>
						)}
						{/*validations.idHocPriority*/}
					</FormGroup>

					{this.hocCardId ? (   //RITM0607600
            <>
              {this.state.hocCardModel.hocCardCAR?.dueDate &&
              this.state.hocCardModel.hocCardCAR?.description &&
              (this.state.hocCardModel.hocCardCAR?.owner || this.state.hocCardModel.hocCardCAR?.ownerSaipem || this.state.hocCardModel.hocCardCAR?.genericOwner) ? (
                <FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
                  <FormLabel className="some-class">{this.state.hocCardTranslate?.statusTitle}</FormLabel>
                  <ComboBox
                    id="status"
                    placeholder={this.state.hocCardTranslate?.statusTitlePlaceholder}
                    name="status"
                    alt="hocCardModel"
                    onChange={this.handleChangeComboStatusModel}
                    itemToString={(item) => item || ""}
                    selectedItem={selectedItemCombo.status}
                    items={this.statuses}
                    disabled={idDisableStatus || this.state.hocCardModel.idHocType === idHocTypePOS} //RITM1070983
                  />
                </FormGroup>
              ) : (
                ""
              )}

							{selectedItemCombo.completionStatus ? (
								<FormGroup legendText="" className="bx--col-lg-4 bx--col-md-4">
									<FormLabel className="some-class">{this.state.hocCardTranslate?.completionStatusTitle}</FormLabel>
									<ComboBox
										id="completionStatus"
										placeholder={this.state.hocCardTranslate?.completionStatusTitlePlaceholder}
										name="completionStatus"
										alt="hocCardModel"
										disableClear={true}
										onChange={this.handleChangeComboCompletionStatusModel}
										itemToString={(item) => item || ""}
										selectedItem={selectedItemCombo.completionStatus}
										items={this.completionStatuses}
										disabled={isDisable}
									/>
								</FormGroup>
							) : (
								""
							)}
            </>
					) : (
						""
					)}
				</div>
				<div className="bx--row">
					<div className="modal-header">
						<div className="bx--modal-header selection-items-list-costum">
							<h3 className="bx--modal-header__heading">{this.state.hocCardTranslate?.carTitle} </h3>{" "}
						</div>
					</div>
				</div>
				<div className="bx--row">
					<FormGroup legendText="" className="bx--col-md-4">
						<FormLabel className="some-class">{this.state.hocCardTranslate?.carDescriptionTitle}</FormLabel>
						<TextInput
							key={"iddescription_" + this.state.hocCardModel.idHocType} //RITM1070983
							id="iddescription"
							name="description"
							placeholder={this.state.hocCardTranslate?.carDescriptionTitlePlaceholder}
							required
							value={!this.state.hocCardModel.hocCardCAR ? "" : this.state.hocCardModel.hocCardCAR.description}
							onChange={this.handleChangeModelCar}
							type="text"
							labelText=""
							className="bx--text-input  bx--text-input--light"
							disabled={isDisable || ((!this.state.hocCardModel.hocCardCAR ? true : ((this.state.hocCardModel.hocCardCAR.description == "" || this.state.hocCardModel.hocCardCAR.description == null) ? true : false)) && this.state.hocCardModel.idHocType === idHocTypePOS)} //RITM1070983
							invalid={validations.carDescription != null}
							invalidText={this.state.hocCardTranslate?.msgCARDescription} //RITM0954296
						/>{" "}
						{/* RITM0954296 */}
						{/* {validations.carDescription} */}
					</FormGroup>
					{/* RITM1070983 */}
					<FormGroup legendText="" className="bx--col-md-4">
						{/* RITM0954296 */}
						<FormLabel className="some-class">{this.state.hocCardModel.idHocType === idHocTypePOS ? (this.state.hocCardTranslate?.dueDateTitle ? this.state.hocCardTranslate.dueDateTitle : "Due Date") : (this.state.hocCardTranslate?.dueDateTitle ? this.state.hocCardTranslate.dueDateTitle + "*" : "Due Date*")}</FormLabel>
						{this.state.isLoadingDate ? (
							<DatePickerSkeleton />
						) : (
							<DateTimePicker
								value={this.state.hocCardModel.hocCardCAR == null ? "" : this.state.hocCardModel.hocCardCAR.dueDate}
								type="date"
								placeholder={DateFormat}
								name="dueDate"
								alt="hocCardCAR"
								invalid={validations.carDueDate != null}
								onChange={this.updateStateDPCAR}
								disabled={isDisable || ((!this.state.hocCardModel.hocCardCAR ? true : (this.state.hocCardModel.hocCardCAR.dueDate == null ? true : false)) && this.state.hocCardModel.idHocType === idHocTypePOS)} //RITM1070983
							/>
						)}
						{validations.duedate ? <div className="srv-validation-message"> {this.state.hocCardTranslate?.dueDateTitlePlaceholder} </div> : null}
						{/* RITM0954296 */}
						{/* {validations.carDueDate} */}
						{validations.carDueDate ? <div className="srv-validation-message"> {this.state.hocCardTranslate?.msgCARDueDate} </div> : null}
					</FormGroup>
				</div>
				<div className="bx--row">
					<FormGroup legendText="" className="bx--col-lg-6 bx--col-md-6">
						<FormLabel className="label-title-description">{this.state.hocCardTranslate?.idEmployerTitle} <br />{this.state.hocCardTranslate?.idEmployerTitle2}</FormLabel>
						<div className="search--custom-text">
							<TextInput
								id="idEmployer"
								name="idEmployer"
								placeholder={this.state.hocCardTranslate?.idEmployerTitlePlaceholder}
								required
								value={
									this.state.hocCardModel.hocCardCAR
										? this.state.hocCardModel.hocCardCAR.owner
											? `${this.state.hocCardModel.hocCardCAR.owner.name} ${this.state.hocCardModel.hocCardCAR.owner.surname}`
											: this.state.hocCardModel.hocCardCAR.genericOwner
											? `${this.state.hocCardModel.hocCardCAR.genericOwner.name} ${this.state.hocCardModel.hocCardCAR.genericOwner.surname}`
											: this.state.hocCardModel.hocCardCAR.ownerSaipem
											? `${this.state.hocCardModel.hocCardCAR.ownerSaipem.name} ${this.state.hocCardModel.hocCardCAR.ownerSaipem.surname}`
											: ""
										: ""
								}
								onChange={this.handleChangeModelCar}
								type="text"
								labelText=""
								className="bx--text-input  bx--text-input--light camp--description "
								disabled
								invalid={validations.carEmployer != null}
								invalidText={this.state.hocCardTranslate?.msgCAROwnerfield} //RITM0954296
							/>{" "}
							{/* RITM0954296 */}
							{/* {validations.carEmployer} */}
						</div>
						<div>
						{/* RITM1070983 */}
						{(this.state.hocCardModel.idHocType !== idHocTypePOS || (this.state.hocCardModel.hocCardCAR ? (this.state.hocCardModel.hocCardCAR?.owner || this.state.hocCardModel.hocCardCAR?.ownerSaipem || this.state.hocCardModel.hocCardCAR?.genericOwner) : false)) ? (
							<Button
								iconDescription={this.state.hocCardTranslate?.deleteCAROwnerTitle}
								tooltipPosition="top"
								tooltipAlignment="center"
								hasIconOnly
								renderIcon={Close16}
								onClick={() => this.deleteEmployer()}
								className="search--custom-button"
								disabled={isDisable}
							/>
						) : (
							""
						)}
						{/* End */}
						</div>
					</FormGroup>
					<FormGroup legendText="" className="bx--col-md-4">
						{/* RITM1070983 */}
						<FormLabel className="some-class">{this.state.hocCardModel.idHocType === idHocTypePOS ? (this.state.hocCardTranslate?.findOwneronGHRSorSaipemTitle ? this.state.hocCardTranslate.findOwneronGHRSorSaipemTitle : "Find Owner on GHRS or Saipem") : (this.state.hocCardTranslate?.findOwneronGHRSorSaipemTitle ? this.state.hocCardTranslate.findOwneronGHRSorSaipemTitle + "*" : "Find Owner on GHRS or Saipem*")} <br />{this.state.hocCardTranslate?.idEmployerTitle2}</FormLabel>
						<div className="bx--row two-button-center">
							<div className="bx--col-lg-6 bx--col-md-6">
								<Button disabled={isDisable || this.state.hocCardModel.idHocType === idHocTypePOS} kind="primary" className="bx--col" title={this.state.hocCardTranslate?.donotUsePATitle} onClick={() => this.handleChangeModal("FindGHRSEmployer")}>
									{this.state.hocCardTranslate?.ghrSresearchTitle}
								</Button>
							</div>
							<div className="bx--col-lg-6 bx--col-md-6">
						
								<Button disabled={isDisable || !selectedItemCombo.idWorkSite || this.state.hocCardModel.idHocType === idHocTypePOS} kind="primary" className="bx--col" onClick={() => this.handleChangeModal("FindSaipemCompilers")}>
									{this.state.hocCardTranslate?.saipemresearchTitle}
								</Button>
							</div>
							<div className="bx--col-lg-6 bx--col-md-6">
								<Button disabled={isDisable || this.state.hocCardModel.idHocType === idHocTypePOS} kind="primary" className="bx--col" title={this.state.hocCardTranslate?.donotUsePATitle} onClick={() => this.handleChangeModal("CAROwnerManualInput")}>
									{this.state.hocCardTranslate?.manualinputTitle}
								</Button>
							</div>
						</div>
					</FormGroup>
					{/* End */}
					<div className="bx--col-lg-12 bottom-group">
						<h3 className="title--medium">{this.state.hocCardTranslate?.attachmentsTitle}</h3>
						<h6>{this.state.hocCardTranslate?.attachmentsTitlePlaceholder}</h6>
						<HocCardAttachments
							attachments={this.state.hocCardModel.attachments}
							addNewAttachment={this.addNewAttachment}
							removeAttachment={this.removeAttachment}
							isDisabled={this.state.isDisabled}
							idHocCard={this.hocCardId}
							onAttachmentSync={this.checkAttachmentAvailability}
							AttachmentName={this.state.hocCardTranslate?.attachmentNameTitle}
							AttachmentType={this.state.hocCardTranslate?.attachmenttypeTitle}
							AttachmentType2={this.state.hocCardTranslate?.attachmenttype2Title}
							AttachmentActions={this.state.hocCardTranslate?.attachmentActionsTitle}
							AttachmentAddnew={this.state.hocCardTranslate?.attachmentAddnewTitle}
							AttachmentSelect={this.state.hocCardTranslate?.hocprioritiesTitlePlaceholder}
							AttachmentTitle={this.state.hocCardTranslate?.attachmentTitle}
							AttachmentChoosefile={this.state.hocCardTranslate?.attachmentChooseFileTitle}
							AttachmentNoRecords={this.state.hocCardTranslate?.noRecordsTitle}
							Attachmentmsg={this.state.hocCardTranslate?.msgattachmentformat}
							AttachmentmsgWarning={this.state.hocCardTranslate?.msgWarning}
							AttachmentmsgError={this.state.hocCardTranslate?.msgError}
							AttachmentmsgPictures={this.state.hocCardTranslate?.msgattachmentPictures}
							AttachmentmsgDocuments={this.state.hocCardTranslate?.msgattachmentDocuments}
							isTranslate={true} //RITM0954296
						/>
					</div>
				</div>

				<div className="searchFormFooter">
					<Button className="button--max-width" kind="secondary" onClick={this.handleCancel}>
						{this.state.hocCardTranslate?.cancelTitle}
					</Button>
					<Button className="button--max-width" kind="primary" onClick={() => this.handleSubmitInsert()}>
						{this.state.hocCardTranslate?.saveTitle}
					</Button>
				</div>
			</Form>
		);
	};

	getStatusActions = () => {
		return (
			<Online>
				<div >
									
					 <label htmlFor="dropdown" >Translate : </label> 
					<select id="idLanguage" value={this.state.selectedLanguage} onChange={this.handleChangeLanguage}  >
						<option value="English">English</option>
						<option value="Italian">Italian</option>
						<option value="Filipino">Filipino</option>
						<option value="Indonesian">Indonesian</option>
						{/* RITM1386795 */}
						<option value="Portuguese">Portuguese</option>
					</select>				
					<> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>	
				</div>
				<div><Button renderIcon={Delete16} onClick={this.openDeleteHocCardConfirmModal}>
						{this.state.hocCardTranslate?.deleteTitle}
					</Button>
				 </div>
				
			</Online>
		);
	};

	render() {
		let hocCardHeader = this.state.hocCardModel && this.state.hocCardModel.code ? "ID: " + this.state.hocCardModel.code : "";

		const confirmDelProps = () => ({
			idToDelete: this.hocCardId,
			nameItem: "",
			isDeleting: this.state.isDeleting,
			open: this.state.isDeleteModalOpen,
			onCloseConfirm: this.onCloseConfirm,
			deleteItem: this.deleteItem,
			msgDeleteConfirm: this.state.hocCardTranslate?.msgDeleteConfirm,
			msgDeleteYes: this.state.hocCardTranslate?.msgDeleteYes,
			msgDeleteNo: this.state.hocCardTranslate?.msgDeleteNo,
		});

		return (
			<AppContext.Consumer>
				{({ user }) => (
					<>
						<PageBreadCrumb
							linkTo={"/hocCard?isBack"}
							linkText="HOCs"
							titleLeft={this.hocCardId ? "Edit HOC" : "New HOC"}
							titleCenter={hocCardHeader}
							titleRight={[this.state.hocCardModel.status, this.state.hocCardModel.completionStatus]}
							batchActions={this.getStatusActions()}
						/>
						<div className="mainContainer">
							<div className="bx--grid content full-width">
								{/* RITM0954296 */}
								{this.state.openModal === "FindGHRSEmployer" ? <FindGHRSEmployer isOpenModal={true} onCancel={() => this.handleChangeModal(null)} onOk={this.setEmployer} isTranslate={true} /> : null} 
								{this.state.openModal === "FindSaipemCompilers" ? (
									<FindSaipemCompilers isOpenModal={true} url={`/hoccard/${this.state.hocCardModel.idWorkSite}/car/compilers/`} onCancel={() => this.handleChangeModal(null)} onOk={this.setSaipemOwner} isTranslate={true} />
								) : null}
								{this.state.openModal === "CAROwnerManualInput" ? (
									<CAROwnerManualInputModal
										editModal={this.state.hocCardModel.hocCardCAR?.idGenericOwner != null}
										editModel={this.state.hocCardModel.hocCardCAR?.genericOwner}
										onCancel={() => this.handleChangeModal(null)}
										onOk={this.setGenericOwner}
										isTranslate={true}
									/>
								) : null}
								{this.renderMainForm(user)}

								<ConfirmAlertCustom {...confirmDelProps()} />
							</div>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}
